<header class="fixed-header">
  <div class="header-left">
    <span [matTooltip]="'Version: ' + (appVersion || '?')" matTooltipPosition="below" style="cursor: help;">
      <mat-icon svgIcon="logoEstiDark" class="header-logo estimator-logo" style="width:155px; height:21px;"></mat-icon>
    </span>
    @if (tenantLogoUrl) {
      <img class="header-logo tenant-logo" [src]="tenantLogoUrl" alt="Tenant logo">
    }
  </div>

  <div class="header-right">
    @if (!isSidenavVisible) {
    <button mat-button class="header-action nav-menu-trigger" [matMenuTriggerFor]="workAreaNavMenu" type="button"
      matTooltip="{{ variables?.navigation || 'Navegación' }}" matTooltipPosition="below">
      <mat-icon class="header-icon-symbol" aria-hidden="true">menu</mat-icon>
      <span class="nav-menu-label">{{ variables?.navigation || 'Navegación' }}</span>
    </button>
    }

    <button class="header-action header-icon-btn" type="button" (click)="openNotifications()"
      matTooltip="{{ variables?.notifications || 'Notificación' }}" matTooltipPosition="below"
      [attr.aria-label]="(variables?.notifications || 'Notifications') + (unreadCount > 0 ? ': ' + unreadCount + ' unread' : '')">
      <mat-icon svgIcon="Notification" class="header-icon-img" aria-hidden="true"></mat-icon>
      @if (unreadCount > 0) {
      <span class="notification-badge">{{ unreadCountLabel }}</span>
      }
    </button>

    <span class="header-role-text">
      {{ variables?.role || 'Role' }}: {{ translatedRole }}
    </span>
    @if (currentUserTenantLabel) {
    <span class="header-role-text ms-2">
      {{ variables?.currentTenantLabel || 'Tenant' }}: {{ currentUserTenantLabel }}
    </span>
    }

    <button mat-button class="header-action header-icon-btn" [matMenuTriggerFor]="languageMenu" type="button"
      matTooltip="{{ variables?.language || 'Language' }}: {{ currentLanguageLabel }}" matTooltipPosition="below">
      <img [src]="currentLanguageFlag" [alt]="(variables?.language || 'Language') + ' flag'" class="header-icon-img">
    </button>

    <a class="header-action header-link header-icon-btn" routerLink="/faqs"
      matTooltip="{{ variables?.faqsAndDocs || 'Help' }}" matTooltipPosition="below" aria-label="Help">
      <mat-icon svgIcon="nformation" class="header-icon-img"></mat-icon>
    </a>

    <button mat-button class="header-action profile-action" [matMenuTriggerFor]="profileMenu"
      #profileMenuTrigger="matMenuTrigger" type="button" matTooltip="{{ variables?.myProfile || 'Mi Perfil' }}"
      matTooltipPosition="below">
      <mat-icon svgIcon="User" class="header-icon-img"></mat-icon>
      <span class="profile-user-name">{{ currentUserName }}</span>
    </button>

    <button class="header-action header-icon-btn logout-action" type="button" (click)="logout()"
      matTooltip="{{ variables?.logOut || 'Log out' }}" matTooltipPosition="below">
      <mat-icon svgIcon="Open-door" class="header-icon-img"></mat-icon>
    </button>
  </div>
</header>

<mat-menu #profileMenu="matMenu" class="profile-menu" panelClass="profile-menu-panel">
  <div class="profile-dialog-surface" (click)="$event.stopPropagation()">
    <div class="profile-menu-header">
      <div class="profile-menu-title">{{ variables?.myProfile || 'Mi Perfile' }}</div>
      <button type="button" class="profile-menu-close" (click)="profileMenuTrigger.closeMenu()"
        [attr.aria-label]="variables?.close || 'Cerrar'">
        <mat-icon aria-hidden="true">close</mat-icon>
      </button>
    </div>

    <div class="profile-menu-content">
      <div class="profile-form-field">
        <label class="profile-field-label" for="profileName">{{ variables?.name || 'Name' }}</label>
        <input id="profileName" class="profile-readonly-input" [value]="currentUserFirstName || '-'" readonly>
      </div>

      <div class="profile-form-field">
        <label class="profile-field-label" for="profileLastName">{{ variables?.lastName || 'Last name' }}</label>
        <input id="profileLastName" class="profile-readonly-input" [value]="currentUserLastName || '-'" readonly>
      </div>

      <div class="profile-form-field">
        <label class="profile-field-label" for="profileEmail">{{ variables?.email || 'Email' }}</label>
        <input id="profileEmail" class="profile-readonly-input" [value]="currentUserEmail || '-'" readonly>
      </div>

      <div class="profile-form-field">
        <label class="profile-field-label" for="profileRole">{{ variables?.role || 'Role' }}</label>
        <input id="profileRole" class="profile-readonly-input" [value]="translatedRole" readonly>
      </div>
      @if (currentUserTenantLabel) {
      <div class="profile-form-field">
        <label class="profile-field-label" for="profileTenant">{{ variables?.currentTenantLabel || 'Tenant' }}</label>
        <input id="profileTenant" class="profile-readonly-input" [value]="currentUserTenantLabel" readonly>
      </div>
      }
    </div>

    <div class="profile-menu-actions">
      <button type="button" class="profile-menu-bottom-close" (click)="profileMenuTrigger.closeMenu()">
        {{ variables?.close || 'Cerrar' }}
      </button>
    </div>
  </div>
</mat-menu>

<mat-menu #languageMenu="matMenu">
  <button mat-menu-item (click)="changeLanguage('pt')">Português</button>
  <button mat-menu-item (click)="changeLanguage('es')">Español</button>
  <button mat-menu-item (click)="changeLanguage('en')">English</button>
</mat-menu>

<mat-menu #workAreaNavMenu="matMenu">
  <button mat-menu-item routerLink="/dashboard">{{ variables?.controlPanel || 'Mis estimaciones' }}</button>
  <!--<button mat-menu-item routerLink="/estimativa">{{ variables?.createEstimation || 'Crear estimación' }}</button>-->
  <button mat-menu-item (click)="navigateToProjects()">{{ variables?.myProjects || 'Mi projectos' }}</button>
  <button mat-menu-item [routerLink]="['/management']" [queryParams]="{ id: 'generic' }">
    {{ variables?.genericCatalog || 'Catálogos genéricos' }}
  </button>
  <button mat-menu-item routerLink="/catalog-stats">{{ variables?.catalogStats || 'Estadísticas catálogo' }}</button>
  <button mat-menu-item routerLink="/perfiles">{{ variables?.profiles || 'Perfiles' }}</button>
  <button mat-menu-item routerLink="/stats">{{ variables?.stats || 'Estadísticas' }}</button>
  <!--@if ((authservice.isSuperAdmin() | async) && variables?.userManagement) {-->
  <button *hasPermission="Permission.USER_MANAGE" mat-menu-item routerLink="/users">{{ variables?.userManagement || variables?.users || 'Gestión de usuarios'
    }}</button>
  <button *hasPermission="Permission.TENANT_MANAGE" mat-menu-item routerLink="/tenants">{{ variables?.tenantMenuLabel || 'Tenants' }}</button>
  <!--}-->
  <!--@if ((authservice.isAdmin() | async) && variables?.techsToolsManagement) {-->
  <button *hasPermission="Permission.TECHNOLOGY_MANAGE" mat-menu-item routerLink="/technologies">{{ variables?.tecsAndTools || 'Tecnologías y herramientas'
    }}</button>
  <!--}-->
</mat-menu>

<!-- Top navbar that shows only for screen smaller than 1200px -->
@if (isSidenavVisible) {
<nav class="navbar navbar-expand-xl navbar-dark bg-dark flex">
  <button class="navbar-toggler" type="button" data-toggle="collapse" (click)="isCollapsed = !isCollapsed"
    data-target="#navbarTogglerDemo01" aria-controls="navbarTogglerDemo01" aria-expanded="false"
    aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  @if (isCollapsed) {
  <img class="me-2" src="../assets/images/Logo_mini_MAPFRE_white.svg" width="50px">
  }
  @if (!isCollapsed) {
  <img class="me-2" src="../assets/images/Logo_MAPFRE_white.svg" width="150px">
  }

  <div class="collapse navbar-collapse" id="navbarTogglerDemo01" [ngbCollapse]=isCollapsed>
    <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
      <li class="nav-item">
        <a (click)="isCollapsed = !isCollapsed" routerLink="/dashboard"
          class="nav-link sidenav-menu-list-item">{{variables.controlPanel}}</a>
        <a (click)="isCollapsed = !isCollapsed" routerLink="/estimativa"
          class="nav-link sidenav-menu-list-item">{{variables.createEstimation}}</a>
        <a (click)="isCollapsed = !isCollapsed" [routerLink]="['/management']" [queryParams]="{ id: 'generic' }"
          [routerLinkActive]="['is-active']" class="nav-link sidenav-menu-list-item">{{variables.genericCatalog}}</a>
        <a (click)="isCollapsed = !isCollapsed" routerLink="/stats" [routerLinkActive]="['is-active']"
          class="nav-link sidenav-menu-list-item">{{variables.stats}}</a>
      </li>
    </ul>

    <div class="item-container ms-3 mb-2">
      <mat-icon svgIcon="Open-door-white" (click)="logout()" style="width:25px; height:25px;"></mat-icon>
      @if (isOpen || shouldPinSidenav) {
      <h4 class="menu-item" mat-line>{{ variables.logOut }} </h4>
      }
    </div>
  </div>


</nav>
}

<div class="grid-page">
  @if (isSidenavVisible) {
  <div class="item-1" [@sidenavWidth]="(isOpen || shouldPinSidenav) ? 'open' : 'closed'"
    [ngClass]="{'grid-page-open': isOpen || shouldPinSidenav}" (mouseenter)="onSidenavMouseEnter()"
    (mouseleave)="onSidenavMouseLeave()" (@sidenavWidth.start)="onSidenavAnimationStart()"
    (@sidenavWidth.done)="onSidenavAnimationDone()">
    <app-sidenav [menuOpen]="isOpen || shouldPinSidenav"></app-sidenav>

    @if ((isOpen || shouldPinSidenav) && !isSidenavAnimating) {
    <div class="lock_icon_out" [ngClass]="{'lock_sidenav_open': isOpen || shouldPinSidenav}" class="lock_sidenav">
      @if (shouldPinSidenav ) {
      <mat-icon svgIcon="Access-Control" (click)="onCheckboxChange(false)" style="width:20px; height:20px;"></mat-icon>
      }
      @if (!shouldPinSidenav && isOpen) {
      <mat-icon svgIcon="Cyber Security" (click)="onCheckboxChange(true)" style="width:20px; height:20px;"></mat-icon>
      }
    </div>
    }

  </div>
  }
  <div class="item-2-container" [ngClass]="{ 'scroll-enabled': isScrollEnabled }">
    <router-outlet></router-outlet>
  </div>
</div>